<template>
  <div style="margin: 41px 40px">
    <Modal
      width="40%"
      v-if="isModalDetail"
      @close="() => (isModalDetail = false)"
    >
      <h1 class="modal-title">Konfirmasi Deactive Data</h1>
      <p style="margin: 20px 0px" class="detail-value">
        Apakah kamu yakin ingin menonaktifkan data transaksi pelanggan ini?
      </p>
      <div class="btn-container-2">
        <button
          @click.prevent="getmodal(false)"
          class="color-text-gray btn-batalkan"
        >
          BATALKAN
        </button>
        <button style="margin-left: 10px" class="color-text-gray btn-simpan-2">
          SIMPAN DATA
        </button>
      </div>
    </Modal>
    <div style="display: flex; align-items: center; margin-bottom: 40px">
      <h5 class="text-page" style="margin-right: 10px">Finance</h5>
      <Arrow :fill="'#4456b4'" :direct="'left'" />
      <h5 class="text-page" style="margin: 10px">(B2C) Event</h5>
      <Arrow :fill="'#4456b4'" :direct="'left'" />
      <h5 class="text-page color-text-gray" style="margin-left: 10px">
        {{ this.category_name }}
      </h5>
      <button @click="goToPage2()" class="ml-auto color-text-gray btn-download">
        <Download :width="20" :height="20" /> Riwayat
      </button>
    </div>
    <div class="body">
      <div v-if="category.length" class="body-content">
        <div
          class="box-category cursor-pointer"
          v-for="(item, index) in category"
          :key="index"
          @click="goToPage(item.id)"
        >
          <div style="margin-right: auto">
            <div class="warp-box-category">
              <div>
                <h1 class="box-category-title" >
                  {{ item.name }}
                </h1>
                <p style="margin-right: auto" class="box-category-text">
                  {{ item.schedule || "01 Mar 2024" }}
                </p>
              </div>
              <div style="margin-left: auto">
                <Arrow :direct="true" />
              </div>
            </div>
            <div class="box-category-count">
              <div>
                <h3 class="box-category-count-title">
                  {{ item.total_session }}
                </h3>
                <h5 class="box-category-count-text">
                  Total <br />
                  Program
                </h5>
              </div>
              <div>
                <h3 class="box-category-count-title">
                  {{ item.total_registered }}
                </h3>
                <h5 class="box-category-count-text">
                  Peserta <br />
                  Terdaftar
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        
        <v-row justify="center" v-if="total_page">
      <v-col cols="4">
        <v-container class="max-width">
          <v-pagination
            v-model="currentPage"
            class="my-4"
            :length="total_page"
            @input="fetchTransactionEvent"
          ></v-pagination>
        </v-container>
      </v-col>
    </v-row>
    <p class="text-jumlah">
          Menampilkan page ke <span style="font-weight: 700">{{ this.currentPage }}</span> dari
          <span style="font-weight: 700">{{ this.total_page }}</span> page
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Arrow from "../../../../../components/icons/Arrow.vue";

export default {
  props: ["categorys"],
  components: {
    Arrow,
  },
  data() {
    return {
      category: [],
      currentPage: 0,
      jumlah: 0,
      category_name: "",
      total_page: 0,
    };
  },
  methods: {
    async fetchTransactionEvent() {
      try {
        const resp = await this.$crm_http.get(`/v1/transaction/event/category/${this.categorys}?page=${this.currentPage}&per_page=12`)
        this.category = resp.data.data.events || [];
        this.jumlah = resp.data.data.pagination.total_data;
        this.category_name = resp.data.data.category_name;
        this.total_page = resp.data.data.pagination.total_page;
      } catch (error) {
        console.error("Error fetching transaction events:", error);
      }
    },
    goToPage(id) {
      this.$router.push(
        `/transaction/b2b/event/${this.category_name
          .toLowerCase()
          .replace(/\s+/g, "-")}/${id}`
      );
    },
    goToPage2() {
      this.$router.push(`/transaction/b2b/event/${this.categorys}/riwayat`);
    },
  },
  mounted() {
    this.fetchTransactionEvent();
  },
};
</script>
<style scoped>
.btn-download {
  background-color: #ffffff;
  color: #7b7e8c;
  width: 156px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid #d3d6e1;
}
.text-page {
  font-weight: 500;
  font-size: 16px;
  color: #162ca2;
}
.color-text-blue {
  color: #4456b4;
}
.color-text-gray {
  color: #acafbf;
}
.text-jumlah {
  font-size: 12px;
  font-weight: 400px;
  margin-top: 46px;
}
.pegenation {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
}
.pegenation-text {
  font-size: 14px;
  font-weight: 700;
  margin-left: 15px;
  margin-right: 15px;
}
.warp-box-category {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.body {
  background: #ffffff;
  padding: 42px 22px;
  border-radius: 10px;
  height: fit-content;
}

.body-content {
  display: grid;
  gap: 25px 35px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  justify-items: center;
}

.box-category2 {
  border: 1px solid #2d46cf;
  width: 100%;
  padding: 15px 25px;
  border-radius: 15px;
}
.box-category {
  border: 1px solid #d3d6e1;
  width: 100%;
  padding: 15px 25px;
  border-radius: 15px;
}
.box-category-count {
  width: 179px;
  display: flex;
  padding: 15px 25px 15px 25px;
  column-gap: 38px;
  background-color: #f1f6ff;
  border-radius: 5px;
}

.box-category-text {
  color: #7b7e8c;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  width: 215px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.box-category-title {
  color: #36373f;
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
}
.box-category-count-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #2d46cf;
}
.box-category-count-text {
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
}
</style>
